import { defineStore } from 'pinia';
import { GET_IS_ACTIVE_OVERLAY, GET_OVERLAY_NAME } from '#shared/types/getters';
import { SET_ACTIVE_OVERLAY_NAME, RESET_OVERLAY } from '#shared/types/actions';

import overlayNames from '#shared/constants/common/overlayNames';

export const useNavOverlay = defineStore('navOverlay', {
  state: () => ({
    activeOverlayName: null,
  }),
  getters: {
    [GET_IS_ACTIVE_OVERLAY](state) {
      return state.activeOverlayName !== null;
    },
    [GET_OVERLAY_NAME](state) {
      return state.activeOverlayName;
    },
  },
  actions: {
    [SET_ACTIVE_OVERLAY_NAME](name) {
      if (overlayNames.includes(name)) {
        this.activeOverlayName = name;
      } else {
        throw new Error(`Invalid overlay name: ${name}`);
      }
    },

    [RESET_OVERLAY]() {
      this.$reset();
    },
  },
});
